// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"daf3169c","657":"7f77bf02","873":"bbdcdf87","925":"87266baa"}[chunkId] + ".chunk.js";
};